export const requestJavaCode = `
        // This is Java code
        import React from 'react';
        import { Button } from '@mui/material';

        const MyButton = () => (
            <Button variant="contained" color="primary">
                Click Me
            </Button>
        );

        export default MyButton;
    `

export const requestPhpCode = `
        // This is Php code
        import React from 'react';
        import { Button } from '@mui/material';

        const MyButton = () => (
            <Button variant="contained" color="primary">
                Click Me
            </Button>
        );

        export default MyButton;
    `

export const requestCPlusCode = `
        // This is C++ code
        import React from 'react';
        import { Button } from '@mui/material';

        const MyButton = () => (
            <Button variant="contained" color="primary">
                Click Me
            </Button>
        );

        export default MyButton;
    `